import { useAuthentication, withAuthenticationContext } from '@psyomics/ui-common';
import { Navigate, useParams } from 'react-router-dom';

import { UploadReferrals as UploadReferralsFeature } from '../../../features/referral-upload-jobs/upload-referrals';

const UploadReferralsForServiceCode = withAuthenticationContext(() => {
  const { serviceCode } = useParams();

  if (!serviceCode) throw new Error('no service code');

  return <UploadReferralsFeature serviceCode={serviceCode} />;
});

const UploadReferrals = () => {
  const { bulkReferralEnabled, organisation } = useAuthentication();

  if (!bulkReferralEnabled) {
    return <Navigate replace to={`/account/${organisation}/home`} />;
  }

  return <UploadReferralsForServiceCode />;
};

export { UploadReferrals };
